<script>
export default {
    data() {
        return {
            show: this.$page.props.uiSwitcher,
            message: '',
            uiForm: this.$inertia.form({
                uiVersion: this.$page.props.uiVersion
            }),
            buttonText: this.$page.props.uiVersion == 6 ? 'Switch Back' : 'Switch Now'
        }
    },
    beforeMount(){
        this.message = this.setMessage()
    },
    methods: {
        setMessage() {
            const v6 = 'You\'re using the new version of our CRM user interface. You can switch back to the previous version at any time.'
            const v5 = 'We\'ve launched a new version of our CRM user interface - try it now! You can switch back at any time.'

            switch (this.uiForm.uiVersion) {
            case 6:
                return v6
            default:
                return v5
            }
        },
        switchUI() {
            switch (this.uiForm.uiVersion) {
            case 5:
                this.uiForm.uiVersion = 6
                break
            default:
                this.uiForm.uiVersion = 5
                break
            }

            this.uiForm.post(
                this.$route('uiswitch')
            )
        }
    }
}
</script>

<template>
    <div class="flex flex-wrap gap-4 justify-center items-center w-full h-12 bg-spotler-honesty">
        <p class="pl-4 text-white font-large">
            {{ message }}
        </p>
        <button
            class="flex items-center px-4 space-x-2 h-8 font-semibold text-white hover:text-spotler-knowledge bg-spotler-knowledge hover:bg-white rounded-full border border-spotler-knowledge focus:outline-none xs"
            dusk="ui-switcher"
            @click="switchUI()"
        >
            <span class="hidden text-xs uppercase lg:block">{{ buttonText }}</span>
        </button>
    </div>
</template>
